/* eslint-disable linebreak-style */
/* eslint-disable camelcase */
import React from 'react';
import Head from 'next/head';
import { useAmp } from 'next/amp';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const TaboolaHead = () => (!useAmp() ? (
  <Head>
    <script
      type="didomi/javascript"
      dangerouslySetInnerHTML={{
        __html: `
          window.onload = function() {
            window._taboola=window._taboola||[];
            window._taboola.push({article:'auto'});
            !function(e,f,u,i){
              if(!document.getElementById(i)){
                e.defer=true;
                e.src=u;
                e.id=i;
                f.parentNode.insertBefore(e,f)
              }
            }(
              document.createElement('script'),
              document.getElementsByTagName('script')[0],
              '${publicRuntimeConfig.taboola_loader}','tb_loader_script'
            );
          }
        `,
      }}
    />
  </Head>
) : null);

export default TaboolaHead;
